import { TextFieldFormsy } from '@fuse';
import * as Actions from 'auth/store/actions/index';
import classNames from 'classnames';
import Formsy from 'formsy-react';
import { Button, Card, CardContent, Grow, Slide, Typography } from 'material-ui';
import { withStyles } from 'material-ui/styles/index';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
//import axios from 'axios/index';

const styles = theme => ({
    root : {
        background    : window.env==="IMC"? "url('/assets/images/backgrounds/imc_logo.jpg') no-repeat ":"url('/assets/images/backgrounds/loginBackground.png') no-repeat ",
        backgroundSize: 'contain',
    },
    intro: {
        color: '#ffffff'
    },
    card : {
        width   : '100%',
        maxWidth: 400
    }
});

class Login extends Component {
    state = {
        canSubmit: false
    };

    form = React.createRef();

    disableButton = () => {
        this.setState({canSubmit: false});
    };

    enableButton = () => {
        this.setState({canSubmit: true});
    };

    onSubmit = (model) => {
        this.props.submitLogin(model);
    };

    componentDidUpdate(prevProps, prevState)
    {
        if ( this.props.login.error && (this.props.login.error.username || this.props.login.error.password) )
        {
            this.form.updateInputsWithError({
                ...this.props.login.error
            });

            this.props.login.error = null;
            this.disableButton();
        }

        if ( this.props.user.data )
        {
            const pathname = this.props.location.state && this.props.location.state.redirectUrl ? this.props.location.state.redirectUrl : '/';
            this.props.history.push({
                pathname
            });
        }
        return null;
    }

    render()
    {
        const {classes} = this.props;
        const {canSubmit} = this.state;

        return (
            <div className={classNames(classes.root, "flex flex-col flex-1 flex-no-shrink p-24 md:flex-row md:p-0")}>

                <div
                    className={classNames(classes.intro, "flex flex-col flex-no-grow items-center p-16 text-center md:p-128 md:items-start md:flex-no-shrink md:flex-1 md:text-left")}>

                     {/* <Grow in={true}>
                        <div className="w-450 mb-32">
                            <img src="assets/images/logos/ICSC 2.png" alt="logo"/>
                        </div>
                    </Grow> */}

                   <Grow in={true} timeout={300}>
                        <Typography variant="display2" color="inherit" className="font-light">
                            {/* Welcome H2BIS */}
                        </Typography>
                    </Grow>

                     <Grow in={true} timeout={600}>
                        <Typography variant="subheading" color="inherit" className="max-w-512 mt-16">
                            {/* Does the Hard Business all easy for You */}
                        </Typography>
                    </Grow>
                </div>

                <Slide in={true} direction="left">
                    <Card className={classNames(classes.card, "mx-auto m-16 md:m-0")}>

                        <CardContent className="flex flex-col items-center justify-center p-32 md:p-48 md:pt-128 ">

                            <Typography variant="title" className="md:w-full mb-32">LOGIN TO YOUR ACCOUNT</Typography>

                            <Formsy
                                onValidSubmit={this.onSubmit}
                                onValid={this.enableButton}
                                onInvalid={this.disableButton}
                                ref={(form) => this.form = form}
                                className="flex flex-col justify-center w-full"
                            >
                                <TextFieldFormsy
                                    className="mb-16"
                                    type="text"
                                    name="username"
                                    label="Username"
                                    validations={{
                                        minLength: 4
                                    }}
                                    validationErrors={{
                                        minLength: 'Min character length is 4'
                                    }}
                                    required
                                />

                                <TextFieldFormsy
                                    className="mb-16"
                                    type="password"
                                    name="password"
                                    label="Password"
                                    validations={{
                                        minLength: 4
                                    }}
                                    validationErrors={{
                                        minLength: 'Min character length is 4'
                                    }}
                                    required
                                />
                                <div className="text-red text-center">{this.props.loginError}</div>
                                <Button
                                    type="submit"
                                    variant="raised"
                                    color="primary"
                                    className="w-full mx-auto mt-16"
                                    aria-label="LOG IN"
                                    disabled={!canSubmit}
                                >
                                    LOGIN
                                </Button>
                            </Formsy>
                            {/* <div className="my-24 flex items-center justify-center">
                                <Divider className="w-32"/>
                                <span className="mx-8 font-bold">OR</span>
                                <Divider className="w-32"/>
                            </div>

                            <Button variant="raised" color="secondary" size="small"
                                    className="normal-case w-192 mb-8">
                                Log in with Google
                            </Button>

                            <Button variant="raised" color="primary" size="small"
                                    className="normal-case w-192">
                                Log in with Facebook
                            </Button> */}

                        </CardContent>
                    </Card>
                </Slide>
            </div>
        )
    }
}

function mapDispatchToProps(dispatch)
{
    return bindActionCreators({
        submitLogin: Actions.submitLogin
    }, dispatch);
}

function mapStateToProps({auth})
{
    return {
        login: auth.login,
        user : auth.user,
        loginError : auth.login.message
    }
}


export default withStyles(styles, {withTheme: true})(withRouter(connect(mapStateToProps, mapDispatchToProps)(Login)));


// WEBPACK FOOTER //
// ./src/main/content/login/Login.js